var map = {
	"./visia-g.png": "2jiU",
	"./visia.png": "rhJi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "q9SQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pay ^\.\/visia.*\.png$
// module id = q9SQ
// module chunks = 1